import PropTypes from 'prop-types'
import React from 'react'
import { FormattedDistance } from 'shared/units'
import styles from './_routeThumb.css'

export function RouteThumb ({ route, isCourse }) {
  let thumb = ''
  let id = ''
  let link = ''

  if (isCourse) {
    thumb = route.thumbnail
    id = route.id
    link = `/courses/${id}`
  } else {
    thumb = route._links.thumbnail[0].href
    id = route._links.self[0].id
    link = `/routes/view/${id}`
  }

  return (
    <div className={styles.routeContainer}>
      <a href={link}>
        <img className={styles.thumb} src={thumb} />
        <div className={styles.details}>
          <div className={styles.name}>{route.name}</div>
          <div className={styles.distance}>
            <FormattedDistance value={route.distance} />
          </div>
        </div>
      </a>
    </div>
  )
}

RouteThumb.propTypes = {
  route: PropTypes.object,
  isCourse: PropTypes.bool,
}

RouteThumb.defaultProps = {
  isCourse: false,
}

export default RouteThumb



// WEBPACK FOOTER //
// ./src/components/home/shared/RouteThumb.jsx